import { connect } from 'react-redux';

import {
  getAllMetadata,
  signBlob,
} from "core/slices/pipelineMonitoring";
import { getAlerts } from "core/slices/serviceMonitoring";
import {
  objectNames,
  loadingMonitoringData,
  navigationOptions,
  loadingAlerts,
  alerts,
  loadingNavigationData,
  getSignedBlob,
  isLoadingSignedBlob,
  getSessionProgressTableData,
} from "core/selectors";

import PipelineMonitoring from '../../../components/pipelineMonitoring/PipelineMonitoring';

export default connect(
  (state) => ({
    objectNames: objectNames(state),
    loadingMonitoringData: loadingMonitoringData(state),
    navigationOptions: navigationOptions(state),
    alerts: alerts(state),
    loadingAlerts: loadingAlerts(state),
    loadingNavigationData: loadingNavigationData(state),
    signedblob: getSignedBlob(state),
    isLoadingSignedBlob: isLoadingSignedBlob(state),
    sessionProgressTableData: getSessionProgressTableData(state),
  }),
  {
    getAllMetadata,
    getAlerts,
    signBlob,
  }
)(PipelineMonitoring);
